<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/extendCommonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "startlastday": "2023-06-14",
              "endlastday": "2023-06-20",
              "startday": "2023-06-21",
              "endday": "2023-06-27",
              "parkuuids": [
                "ac5fe049-c351-40ec-9858-384e21138dde"
              ]
            },
            responseCode: {
                "data": {
                    "weekTradeList": [
                        {
                            "day": "2023-06-21",
                            "dayDate": 1687276800000,
                            "income": 0.0,
                            "lastDayDate": 1686672000000,
                            "lastday": "2023-06-14",
                            "lastincome": 0.0,
                            "rate": "0%"
                        }
                    ]

                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "通过此接口可获取本周与上一周收入数据比对",
                t_url: this.commonUrls.test+"extend/getWeekorLastIncome",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startlastday', info2: '是', info3: 'String', info4: '上周开始时间' },
                        { info1: 'endlastday', info2: '是', info3: 'String', info4: '上周结束时间' },
                        { info1: 'startday', info2: '是', info3: 'String', info4: '本周开始时间' },
                        { info1: 'endday', info2: '是', info3: 'String', info4: '本周结束时间' },
                        { info1: 'parkuuids', info2: '是', info3: 'JSONArray', info4: '车场UUID列表' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'day', info2: '是', info3: 'String', info4: '本周其中一天' },
                        { info1: 'dayDate', info2: '是', info3: 'String', info4: '本周其中一天的时间戳' },
                        { info1: 'income', info2: '是', info3: 'String', info4: '本周其中一天的收入' },
                        { info1: 'lastDayDate', info2: '是', info3: 'String', info4: '上周其中一天的时间戳' },
                        { info1: 'lastday', info2: '是', info3: 'String', info4: '上周其中一天' },
                        { info1: 'lastincome', info2: '是', info3: 'String', info4: '上周其中一天的收入' },
                        { info1: 'rate', info2: '是', info3: 'String', info4: '增长率' },
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/other/getWeekorLastIncome.vue